import { writable } from 'svelte/store';

export const totalScore = writable(0);

export const bpScore = writable(0);
export const pulseScore = writable(0);
export const tempScore = writable(0);
export const respScore = writable(0);
export const satScore = writable(0);

export const training = [
    { "name": "Jeb",
      "Gender": "male",
      "Age": 72,
      "HPI": "3 day history of dry cough and sore throat",
      "PMH": "Hypertension, High Cholesterol",
      "Meds": "Lisinopril",
      "SBP": 108,
      "DBP": 65,
      "Pulse": 117,
      "Temp": 37.3,
      "RR": 12,
      "Sat": 88,
      "Severity":[],
      "Escalate":[],
    },
    { "name": "Angel",
      "Gender": "female",
      "Age": 17,
      "HPI": "Feels short of breath when climbing stairs",
      "PMH": "No past medical history",
      "Meds": "None",
      "SBP": 125,
      "DBP": 70,
      "Pulse": 63,
      "Temp": 37.6,
      "RR": 21,
      "Sat": 87,
      "Severity":[],
      "Escalate":[],
    },
    { "name": "Levi",
      "Gender": "male",
      "Age": 55,
      "HPI": "Congestion and Headache",
      "Meds": "Albuterol inhaler",
      "PMH": "Asthma",
      "SBP": 155,
      "DBP": 88,
      "Pulse": 120,
      "Temp": 38.6,
      "RR": 19,
      "Sat": 95,
      "Severity":[],
      "Escalate":[],
    },
    { "name": "Kit",
      "Gender": "female",
      "Age": 33,
      "HPI": "Burning with urination",
      "PMH": "None",
      "SBP": 120,
      "DBP": 70,
      "Pulse": 85,
      "Temp": 38.7,
      "RR": 15,
      "Sat": 95,
      "Severity":[],
      "Escalate":[],
    },
    { "name": "Grace",
      "Gender": "female",
      "Age": 83,
      "HPI": "Hip pain, not eating well lately",
      "PMH": "Hypertension, Osteoarthritis, Hiatal Hernia",
      "SBP": 180,
      "DBP": 100,
      "Pulse": 80,
      "Temp": 37.3,
      "RR": 15,
      "Sat": 93,
      "Severity":[],
      "Escalate":[],
    }


]